import { render, staticRenderFns } from "./PagamentoForm.vue?vue&type=template&id=637b6ed0"
import script from "./PagamentoForm.vue?vue&type=script&lang=js"
export * from "./PagamentoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports